import { LayoutApp } from "@/components/layoutApp";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CadastroONG from "./ong/CadastroONG";
import CadastroTutor from "./tutor/CadastroTutor";

function MainCadastro() {
  const [tipoUsuario, setTipoUsuario] = useState<"tutor" | "ong" | null>(null);

  const navigate = useNavigate();

  const ProgressBarComponent: React.FC<{currentStep: number, totalSteps: number}> = ({currentStep, totalSteps}) => (
    <div className="mb-8 mt-4">
      <div className="flex justify-between mb-2">
        <p className="text-sm text-gray-500 font-medium">
          Passo {currentStep} de {totalSteps}
        </p>
        <p className="text-sm text-blue-500 font-medium">
          {Math.round((currentStep / totalSteps) * 100)}%
        </p>
      </div>
      <Progress 
        value={(currentStep / totalSteps) * 100} 
        className="h-2 bg-gray-200"
      />
    </div>
  );

  const UserTypeCard: React.FC<{
    title: string;
    description: string;
    color: string;
    icon: string;
    onPress: () => void;
    isSelected: boolean;
  }> = ({ title, description, color, icon, onPress, isSelected }) => (
    <button
      className={cn(
        "w-full bg-white border-2 rounded-xl p-5 mb-4 shadow-sm transition-all duration-200 hover:shadow-md",
        "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      )}
      style={{ borderColor: isSelected ? color : '#e5e7eb' }}
      onClick={onPress}
    >
      <div className="flex items-center">
        <div 
          className="w-12 h-12 rounded-full flex items-center justify-center text-white text-xl"
          style={{ backgroundColor: color }}
        >
          {icon}
        </div>
        <div className="ml-4 flex-1 text-left">
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
          <p className="text-gray-500 text-sm mt-1">{description}</p>
        </div>
        <div 
          className="w-6 h-6 border-2 rounded-full flex items-center justify-center"
          style={{ borderColor: color }}
        >
          <div 
            className={cn(
              "w-3 h-3 rounded-full transition-opacity duration-200",
              isSelected ? "opacity-100" : "opacity-0"
            )}
            style={{ backgroundColor: color }} 
          />
        </div>
      </div>
    </button>
  );

  return (
  <LayoutApp header={{ title: "Cadastro", backButton: true, onBack: () => navigate("/") }}>
      <div className="max-w-7xl mx-auto px-4 py-4">
        <h1 className="text-3xl font-bold text-center text-blue-600 mb-6">
          Cadastre-se
        </h1>

        {!tipoUsuario ? (
          <>
            <ProgressBarComponent currentStep={1} totalSteps={4} />
            <div className="bg-white px-2 py-4 rounded-3xl shadow-sm">
              <h2 className="text-xl font-semibold mb-2 text-gray-800">
                Tipo de Cadastro
              </h2>
              <p className="text-gray-500 mb-6">
                Escolha o tipo de perfil que deseja criar
              </p>

              <UserTypeCard
                title="Tutor"
                description="Para pessoas que desejam adotar ou já possuem animais de estimação"
                color="#3b82f6"
                icon="🐾"
                isSelected={tipoUsuario === "tutor"}
                onPress={() => setTipoUsuario("tutor")}
              />

              <UserTypeCard
                title="ONG"
                description="Para organizações que trabalham com resgate e adoção de animais"
                color="#10b981"
                icon="🏠"
                isSelected={tipoUsuario === "ong"}
                onPress={() => setTipoUsuario("ong")}
              />
            </div>
          </>
        ) : tipoUsuario === "tutor" ? (
          <CadastroTutor 
            onBack={() => setTipoUsuario(null)} 
          />
        ) : (
          <CadastroONG 
            onBack={() => setTipoUsuario(null)} 
          />
        )}
      </div>
  </LayoutApp>
  );
}

export default MainCadastro;
